import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// eslint-disable-next-line
import MyLandbot from "./MyLandbot";
import { listBotDetails } from "../actions/botActions";
import { useParams } from "react-router-dom";
import DashHeader from "./DashHeader";

function LandbotContainer() {
  // Set up dispatch and params hooks
  const dispatch = useDispatch();
  let param = useParams();

  // Query bot details from db and pass to redux
  useEffect(() => {
    dispatch(listBotDetails(param.id));
  }, [dispatch, param.id]);
  // Get bot details from global state
  const botDetails = useSelector((state) => state.botDetails);
  const { bot } = botDetails;
  const url = bot?.link;
  

  /* Get SME Details from Global State */
  const { sme } = useSelector((state) => state.userSMEDetails);
  const smeName = sme.name;
  const { type } = sme;

  /* Get Bot History from globalstate */
  const historyid = param.historyid;
  console.log(historyid);

  console.log("The type is ", type);
  console.log("SME.name is", smeName);
  /*   
  console.log("SME Details:", name) */

  // Get user details from global state
  const { userInfo } = useSelector((state) => state.userLogin);
  const { id } = userInfo;
  const { email } = userInfo;
  const { name } = userInfo;

  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <DashHeader pageTitle={"Legal Product"} />
      <Row className="dashboard-content-container">
        {url ? (
          <MyLandbot
            url={url}
            userId={id}
            email={email}
            name={smeName}
            userName={name}
            botHistory={historyid}
          />
        ) : (
          ""
        )}
      </Row>
    </Col>
  );
}

export default LandbotContainer;
